/* Product funnel interactions with the native Shopify AJAX cart. */
(() => {
  'use strict';

  const init = () => {
    if (document.documentElement.dataset.productPreviewInitialized) return;
    document.documentElement.dataset.productPreviewInitialized = 'true';
    document.documentElement.classList.replace('no-js', 'js');

    const $ = (selector, scope = document) => scope.querySelector(selector);
    const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
    const returnLinks = $$('[data-advertorial-return]');
    const commerceOrigin = new URL(document.body.dataset.checkoutStore || window.location.origin, window.location.href).origin;
    const advertorialReturn = window.location.origin === commerceOrigin
      ? document.body.dataset.advertorialProduction : document.body.dataset.advertorialLocal;
    if (advertorialReturn) returnLinks.forEach((link) => { link.href = advertorialReturn; });

    // Section jumps must not add steps between the product and the article on Back.
    document.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href^="#"]');
      const hash = link?.getAttribute('href');
      if (!hash || hash === '#') return;
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      const url = new URL(window.location.href);
      url.hash = hash;
      history.replaceState(history.state, '', url);
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    const money = (value, currency = 'EUR') => new Intl.NumberFormat('fr-FR', {
      style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(value);
    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scrollBehavior = () => reduceMotion.matches ? 'auto' : 'smooth';
    const dialogs = [];
    let savedOverflow = '';
    const focusable = (root) => $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', root)
      .filter((node) => node.getClientRects().length && !node.closest('[hidden], [inert]'));
    const activateDialog = (node, close, focusTarget) => {
      if (dialogs.some((dialog) => dialog.node === node)) return;
      const opener = document.activeElement;
      if (!dialogs.length) {
        savedOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      dialogs.push({ node, close, opener });
      document.documentElement.classList.add('product-dialog-open');
      requestAnimationFrame(() => (focusTarget || focusable(node)[0] || node).focus({ preventScroll: true }));
    };
    const deactivateDialog = (node) => {
      const index = dialogs.findIndex((dialog) => dialog.node === node);
      if (index < 0) return;
      const [dialog] = dialogs.splice(index, 1);
      if (!dialogs.length) { document.body.style.overflow = savedOverflow; document.documentElement.classList.remove('product-dialog-open'); }
      if (dialog.opener?.isConnected) dialog.opener.focus({ preventScroll: true });
    };
    document.addEventListener('keydown', (event) => {
      const dialog = dialogs.at(-1);
      if (!dialog) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        dialog.close();
      } else if (event.key === 'Tab') {
        const nodes = focusable(dialog.node);
        if (!nodes.length) {
          event.preventDefault();
          dialog.node.focus();
        } else if (event.shiftKey && (document.activeElement === nodes[0] || !dialog.node.contains(document.activeElement))) {
          event.preventDefault();
          nodes.at(-1).focus();
        } else if (!event.shiftKey && (document.activeElement === nodes.at(-1) || !dialog.node.contains(document.activeElement))) {
          event.preventDefault();
          nodes[0].focus();
        }
      }
    });

    // The gallery retains Dawn IDs/data-targets and native horizontal scrolling on mobile.
    const galleries = [];
    $$('media-gallery').forEach((gallery) => {
      const slides = $$('.product__media-list > .product__media-item', gallery);
      const strip = $('.product__media-list', gallery);
      const thumbs = $$('.thumbnail-list__item', gallery);
      const thumbStrip = $('.thumbnail-list', gallery);
      const status = $('[id^="GalleryStatus"]', gallery);
      const mobile = window.matchMedia('(max-width: 749px)');
      if (!slides.length || !strip) return;
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      const modalOpener = $('modal-opener', slides[0]);
      const modal = modalOpener ? $(modalOpener.dataset.modal) : null;
      const modalImages = modal ? $$('.product-media-modal__content > img', modal) : [];
      const syncModal = () => {
        modalImages.forEach((image, index) => {
          image.classList.toggle('active', index === current);
          image.style.display = index === current ? 'block' : 'none';
          if (index !== current) return;
          const source = $('.product__media img', slides[index]);
          if (!source) return;
          ['src', 'srcset', 'alt', 'width', 'height'].forEach((attr) => {
            if (source.hasAttribute(attr)) image.setAttribute(attr, source.getAttribute(attr));
            else image.removeAttribute(attr);
          });
          if (source.dataset.fullSrc) { image.src = source.dataset.fullSrc; image.removeAttribute('srcset'); }
        });
      };
      const select = (index, move = true) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          slide.classList.toggle('is-active', position === current);
          slide.setAttribute('aria-hidden', String(position !== current));
        });
        thumbs.forEach((thumb) => {
          const button = $('button', thumb);
          const selected = thumb.dataset.target === slides[current].dataset.mediaId;
          button?.setAttribute('aria-current', selected ? 'true' : 'false');
          if (selected && move && thumbStrip) {
            const left = thumb.offsetLeft - thumbStrip.offsetLeft;
            if (left < thumbStrip.scrollLeft || left + thumb.offsetWidth > thumbStrip.scrollLeft + thumbStrip.clientWidth) {
              thumbStrip.scrollTo({ left: Math.max(0, left - thumbStrip.clientWidth / 2 + thumb.offsetWidth / 2), behavior: scrollBehavior() });
            }
          }
        });
        const counter = $('.slider-counter--current', gallery);
        if (counter) counter.textContent = String(current + 1);
        if (status) status.textContent = `Image ${current + 1} sur ${slides.length}`;
        if (mobile.matches && move) {
          const target = slides[current].getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
          strip.scrollTo({ left: target, behavior: scrollBehavior() });
        }
        if (modal?.hasAttribute('open')) syncModal();
      };
      thumbs.forEach((thumb, index) => $('button', thumb)?.addEventListener('click', () => select(index)));
      gallery.addEventListener('click', (event) => {
        const arrow = event.target.closest('.slider-button');
        if (!arrow) return;
        const direction = arrow.classList.contains('slider-button--prev') ? -1 : 1;
        if (arrow.closest('[id^="GalleryThumbnails"]') && thumbStrip) {
          thumbStrip.scrollBy({ left: direction * thumbStrip.clientWidth * 0.8, behavior: scrollBehavior() });
        } else select(current + direction);
      });
      gallery.addEventListener('keydown', (event) => {
        if (!event.target.closest('.thumbnail')) return;
        const next = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: slides.length - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        select(next);
        $('button', thumbs[current])?.focus({ preventScroll: true });
      });
      let scrollFrame = 0;
      strip.addEventListener('scroll', () => {
        if (!mobile.matches || scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = 0;
          const left = strip.getBoundingClientRect().left;
          const nearest = slides.reduce((best, slide, index) =>
            Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best, 0);
          if (nearest !== current) select(nearest, false);
        });
      }, { passive: true });
      if (modal) {
        const zoomButton = make('button', 'gallery-zoom-button', 'Agrandir');
        zoomButton.type = 'button';
        zoomButton.setAttribute('aria-label', 'Agrandir le détail');
        zoomButton.setAttribute('aria-pressed', 'false');
        modal.append(zoomButton);
        zoomButton.addEventListener('click', () => {
          const zoomed = modal.classList.toggle('is-zoomed');
          zoomButton.textContent = zoomed ? 'Vue complète' : 'Agrandir';
          zoomButton.setAttribute('aria-pressed', String(zoomed));
        });
        const close = () => { modal.removeAttribute('open'); deactivateDialog(modal); };
        const open = (index) => {
          modal.classList.remove('is-zoomed');
          zoomButton.textContent = 'Agrandir';
          zoomButton.setAttribute('aria-pressed', 'false');
          select(index, false);
          syncModal();
          modal.setAttribute('open', '');
          activateDialog(modal, close, $('.product-media-modal__toggle', modal));
        };
        $('.product-media-modal__toggle', modal)?.addEventListener('click', close);
        modal.addEventListener('click', (event) => {
          if (event.target === modal || event.target.classList.contains('product-media-modal__dialog')) close();
        });
        modal.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          select(current + (event.key === 'ArrowLeft' ? -1 : 1), false);
        });
        slides.forEach((slide, index) => {
          const image = $('.product__media', slide);
          if (!image) return;
          $('.product__media-toggle', slide)?.addEventListener('click', () => open(index));
          image.tabIndex = 0;
          image.setAttribute('role', 'button');
          image.setAttribute('aria-label', `Agrandir l’image ${index + 1}`);
          image.addEventListener('click', () => open(index));
          image.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            open(index);
          });
        });
      }
      mobile.addEventListener('change', () => select(current, false));
      select(current, false);
      galleries.push({ gallery, select });
    });

    // Variant identity, price and availability come from the current Shopify product.
    let productData = {};
    try { productData = JSON.parse($('#veranelle-product-data')?.textContent || '{}'); }
    catch { /* Invalid metadata leaves unavailable offers disabled rather than inventing IDs. */ }
    const variants = Array.isArray(productData.variants) ? productData.variants : [];
    const radios = $$('variant-radios input[type="radio"], [data-cure-picker] input[type="radio"]');
    const offers = radios.map((radio) => {
      const variantId = String(radio.dataset.shopifyVariantId || radio.dataset.variantId || '');
      const variant = variants.find((entry) => String(entry.id) === variantId);
      const price = variant ? Number(variant.price) / 100 : Number(radio.dataset.price);
      const valid = /^\d+$/.test(variantId) && Number.isFinite(price) && price >= 0;
      const available = valid && (variant ? variant.available === true : radio.dataset.available === 'true');
      radio.disabled = true;
      return {
        id: radio.dataset.offerId || variantId,
        months: Number(radio.dataset.cureMonths) || parseInt(radio.value, 10) || 1,
        price, bottles: Number(radio.dataset.bottles) || 1,
        variantId, available,
        mediaIndex: radio.dataset.mediaIndex === undefined ? null : Number(radio.dataset.mediaIndex),
        radio,
      };
    });
    let interactionsReady = false;
    let mutationPending = false;
    let checkoutPending = false;
    const selectionFromURL = () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      return offers.find((offer) => offer.variantId === id);
    };
    let selectedOffer = selectionFromURL()
      || offers.find((offer) => offer.variantId === String(productData.selected_variant_id))
      || offers.find((offer) => offer.radio.checked) || offers[0];
    const atcButtons = () => $$('.atc-button, [data-cure-cta], [data-local-add-to-cart], .sticky-cart-button.uplinkly-sticky-cart-button');
    const syncButtons = () => {
      offers.forEach((offer) => { offer.radio.disabled = !interactionsReady || !offer.available || mutationPending || checkoutPending; });
      atcButtons().forEach((button) => {
        const unavailable = !selectedOffer?.available;
        button.disabled = !interactionsReady || unavailable || mutationPending || checkoutPending;
        button.setAttribute('aria-disabled', String(button.disabled));
        button.setAttribute('aria-busy', String(mutationPending));
        const target = $('span', button) || button;
        target.textContent = unavailable ? 'Indisponible' : (button.dataset.ctaPrefix || 'Acheter maintenant');
        if (selectedOffer) button.setAttribute('aria-label', `${target.textContent}, cure ${selectedOffer.months} mois, ${money(selectedOffer.price)}`);
        $('.loading-overlay__spinner', button)?.classList.toggle('hidden', !mutationPending);
      });
    };
    const updateOffer = (offer, updateURL = true) => {
      if (!offer) { syncButtons(); return; }
      selectedOffer = offer;
      offers.forEach((entry) => { entry.radio.checked = entry === offer; });
      const bundle = offer.months > 1 ? `${offer.months} + 1 offert · ` : '';
      const summary = `${bundle}${offer.bottles} flacon${offer.bottles > 1 ? 's' : ''} de 60 ml · Sans abonnement`;
      $$('[data-cure-price], .product-page-price .price__regular .price-item--regular, .product-page-price .price__sale > .price-item--sale')
        .forEach((node) => { node.textContent = money(offer.price); });
      $$('[data-cure-summary]').forEach((node) => { node.textContent = summary; });
      $$('product-form input[name="id"], [data-local-product-form] input[name="id"]').forEach((input) => {
        input.value = offer.variantId;
        input.dataset.selectedId = offer.variantId;
        input.disabled = !offer.available;
      });
      if (updateURL && /^\d+$/.test(offer.variantId)) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', offer.variantId);
        history.replaceState(history.state, '', url);
      }
      syncButtons();
      if (Number.isInteger(offer.mediaIndex)) galleries[0]?.select(offer.mediaIndex);
      document.dispatchEvent(new CustomEvent('veranelle:offer-change', { detail: {
        id: offer.variantId, months: offer.months, price: offer.price, bottles: offer.bottles,
      } }));
    };
    offers.forEach((offer) => offer.radio.addEventListener('change', () => {
      if (offer.radio.checked) updateOffer(offer);
    }));
    updateOffer(selectedOffer);

    // The session cart belongs to Shopify; no local shadow cart or custom pixel events.
    const drawer = $('cart-drawer');
    const configuredRoot = window.Shopify?.routes?.root || document.body.dataset.routesRoot || '/';
    const routeRoot = configuredRoot.endsWith('/') ? configuredRoot : `${configuredRoot}/`;
    const route = (path) => `${routeRoot}${path}`;
    let cart = { items: [], item_count: 0, total_price: 0, currency: 'EUR' };
    let cartLoaded = false;
    let refreshVersion = 0;
    const productTitle = () => productData.title || $('.product__title h1')?.textContent.trim() || 'Veranelle';
    const productImage = () => $('.product__media img');
    const cartError = (message = '') => {
      const error = $('#CartDrawer-CartErrors', drawer || document);
      if (error) error.textContent = message;
    };
    const productError = (message = '') => {
      $$('.product-form__error-message-wrapper').forEach((wrapper) => {
        wrapper.hidden = !message;
        const messageNode = $('.product-form__error-message', wrapper);
        if (messageNode) messageNode.textContent = message;
      });
      // Sticky buttons need an error within the opened drawer as well.
      cartError(message);
    };
    const cartRequest = async (path, payload) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(route(path), {
          method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
          signal: controller.signal,
          headers: payload ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
          ...(payload ? { body: JSON.stringify(payload) } : {}),
        });
        let data;
        try { data = await response.json(); }
        catch (error) {
          if (controller.signal.aborted) throw error;
          throw new Error('Le panier est momentanément indisponible. Veuillez réessayer.');
        }
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Impossible de mettre à jour le panier. Veuillez réessayer.');
        return data;
      } catch (error) {
        if (controller.signal.aborted) throw new Error('La connexion prend trop de temps. Vérifiez votre connexion puis réessayez.');
        throw error;
      } finally { clearTimeout(timeout); }
    };
    const closeCart = () => {
      if (!drawer) return;
      drawer.classList.remove('active', 'animate');
      drawer.setAttribute('aria-hidden', 'true');
      deactivateDialog(drawer);
    };
    const openCart = () => {
      if (!drawer) { window.location.assign(route('cart')); return; }
      drawer.classList.add('animate', 'active');
      drawer.setAttribute('aria-hidden', 'false');
      activateDialog(drawer, closeCart, $('.drawer__close', drawer));
    };
    const renderCart = () => {
      const quantity = cart.item_count || 0;
      const total = cart.total_price / 100;
      const currency = cart.currency || 'EUR';
      const bubbleRoot = $('#cart-icon-bubble');
      if (bubbleRoot) {
        let bubble = $('.cart-count-bubble', bubbleRoot);
        if (!bubble && quantity) { bubble = make('div', 'cart-count-bubble'); bubbleRoot.append(bubble); }
        if (bubble) {
          bubble.replaceChildren(make('span', '', String(quantity)), make('span', 'visually-hidden', `${quantity} article${quantity > 1 ? 's' : ''} dans le panier`));
          bubble.hidden = quantity === 0;
          bubble.style.display = quantity ? '' : 'none';
        }
      }
      if (!drawer) return;
      drawer.setAttribute('aria-busy', String(mutationPending || !cartLoaded));
      drawer.classList.toggle('is-empty', quantity === 0 && cartLoaded);
      $('cart-drawer-items', drawer)?.classList.toggle('is-empty', quantity === 0 && cartLoaded);
      const empty = $('.drawer__inner-empty', drawer);
      if (empty) empty.style.display = quantity || !cartLoaded ? 'none' : '';
      const content = $('#CartDrawer-CartItems', drawer);
      if (content) {
        content.replaceChildren();
        if (!cartLoaded) content.append(make('p', '', 'Chargement du panier…'));
        const table = make('table', 'cart-items');
        const tbody = make('tbody');
        table.append(tbody);
        (cart.items || []).forEach((item) => {
          const row = make('tr', 'cart-item');
          const media = make('td', 'cart-item__media');
          const source = item.featured_image?.url || item.image || (String(item.product_id) === String(productData.id) ? productImage()?.getAttribute('src') : '');
          const title = item.product_title || item.title || productTitle();
          if (source) {
            const image = make('img', 'cart-item__image');
            // Ask Shopify for a thumbnail, not the original 1254px product photo.
            const imageURL = new URL(source, window.location.href);
            if (imageURL.pathname.includes('/cdn/shop/') || imageURL.hostname === 'cdn.shopify.com') imageURL.searchParams.set('width', '200');
            image.src = imageURL.href;
            image.alt = item.featured_image?.alt || title;
            image.width = 100; image.height = 100; image.loading = 'lazy';
            media.append(image);
          }
          const details = make('td', 'cart-item__details');
          details.append(make('p', 'cart-item__name h4 break', title));
          if (item.variant_title && item.variant_title !== 'Default Title') details.append(make('p', 'product-option', item.variant_title));
          details.append(make('p', 'product-option', money((item.final_price ?? item.price) / 100, currency)));
          (item.line_level_discount_allocations || []).forEach((discount) => {
            if (discount.discount_application?.title) details.append(make('p', 'product-option', discount.discount_application.title));
          });
          const totals = make('td', 'cart-item__totals right');
          totals.append(make('span', 'price price--end', money((item.final_line_price ?? item.line_price) / 100, currency)));
          const controls = make('td', 'cart-item__quantity');
          const quantityBox = make('div', 'quantity');
          [-1, 1].forEach((step) => {
            const button = make('button', 'quantity__button no-js-hidden', step < 0 ? '−' : '+');
            button.type = 'button';
            button.setAttribute('aria-label', `${step < 0 ? 'Diminuer' : 'Augmenter'} la quantité de ${title}`);
            button.disabled = mutationPending || checkoutPending || (step > 0 && item.quantity >= 99);
            button.addEventListener('click', () => changeQuantity(item.key, Math.max(0, item.quantity + step)));
            quantityBox.append(button);
            if (step < 0) {
              const count = make('span', 'quantity__input', String(item.quantity));
              count.setAttribute('aria-label', `Quantité : ${item.quantity}`);
              quantityBox.append(count);
            }
          });
          const remove = make('button', 'button button--tertiary', 'Retirer');
          remove.type = 'button'; remove.disabled = mutationPending || checkoutPending;
          remove.setAttribute('aria-label', `Retirer ${title}`);
          remove.addEventListener('click', () => changeQuantity(item.key, 0));
          controls.append(quantityBox, remove);
          row.append(media, details, totals, controls);
          tbody.append(row);
        });
        content.append(table);
        const live = make('p', 'visually-hidden', `${quantity} article${quantity > 1 ? 's' : ''}, total ${money(total, currency)}`);
        live.id = 'CartDrawer-LiveRegionText'; live.setAttribute('role', 'status'); content.append(live);
      }
      $$('.totals__subtotal-value', drawer).forEach((node) => { node.textContent = money(total, currency); });
      const checkout = $('#CartDrawer-Checkout', drawer);
      if (checkout) {
        checkout.disabled = !cartLoaded || !quantity || mutationPending || checkoutPending;
        checkout.setAttribute('aria-disabled', String(checkout.disabled));
        checkout.setAttribute('aria-busy', String(checkoutPending));
      }
    };
    const refreshCart = async () => {
      const version = ++refreshVersion;
      const result = await cartRequest('cart.js');
      if (version === refreshVersion) { cart = result; cartLoaded = true; renderCart(); }
    };
    const acceptCart = (result) => {
      if (!result || !Array.isArray(result.items) || !Number.isInteger(result.item_count)) return false;
      cart = result; cartLoaded = true; renderCart();
      return true;
    };
    // A POST is never retried automatically. A fresh GET may prove it completed.
    const requestAndConfirm = async (path, payload, confirmed) => {
      ++refreshVersion;
      try {
        const result = await cartRequest(path, payload);
        if (!acceptCart(result)) await refreshCart();
        if (!confirmed(cart)) throw new Error('Le panier a changé. Vérifiez votre sélection avant de continuer.');
      } catch (error) {
        try {
          await refreshCart();
          if (confirmed(cart)) return;
        } catch { /* Keep the last confirmed cart; do not repeat an ambiguous POST. */ }
        throw error;
      }
    };
    const mutateCart = async (path, payload) => {
      if (mutationPending || checkoutPending) return false;
      mutationPending = true;
      ++refreshVersion;
      cartError(); productError(); syncButtons(); renderCart();
      try {
        const original = cart.items.find((item) => item.key === payload.id);
        const identity = (item) => JSON.stringify([
          String(item.product_id), String(item.variant_id ?? item.id),
          Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)),
          item.selling_plan_allocation?.selling_plan?.id ?? item.selling_plan ?? null,
        ]);
        const confirmed = (current) => {
          const line = current.items.find((item) => item.key === payload.id);
          if (line) return line.quantity === payload.quantity;
          // Discounts may regenerate a line key. Never confuse distinct custom lines.
          const matches = original ? current.items.filter((item) => identity(item) === identity(original)) : [];
          return payload.quantity === 0 ? !matches.length
            : matches.length === 1 && matches[0].quantity === payload.quantity;
        };
        await requestAndConfirm(path, payload, confirmed);
        return true;
      } catch (error) {
        productError(error.message || 'Impossible de mettre à jour le panier. Veuillez réessayer.');
        return false;
      } finally { mutationPending = false; syncButtons(); renderCart(); }
    };
    const changeQuantity = async (key, quantity) => {
      if (mutationPending || !Number.isInteger(quantity) || quantity < 0 || quantity > 99) return;
      await mutateCart('cart/change.js', { id: key, quantity });
      $('.quantity__button', drawer)?.focus({ preventScroll: true });
    };
    const startCheckout = () => {
      if (checkoutPending || mutationPending || !cartLoaded || !cart.item_count) return;
      checkoutPending = true; cartError(); syncButtons(); renderCart();
      window.location.assign(route('checkout'));
    };
    const cureVariantIds = new Set(variants.map((variant) => String(variant.id)));
    const cureLines = (current) => current.items.filter((item) =>
      String(item.product_id) === String(productData.id) && cureVariantIds.has(String(item.variant_id ?? item.id)));
    const plainCureLine = (item) => !item.selling_plan_allocation && !item.selling_plan
      && !Object.values(item.properties || {}).some((value) => value !== null && value !== '');
    const purchaseConfirmed = (current, variantId) => {
      const lines = cureLines(current);
      return lines.length === 1 && plainCureLine(lines[0]) && lines[0].quantity === 1
        && String(lines[0].variant_id ?? lines[0].id) === variantId;
    };
    const ensureSingleCure = async (variantId) => {
      await refreshCart();
      const initial = cureLines(cart);
      // Preserve deliberately larger/custom/subscription carts rather than guessing intent.
      if (initial.some((item) => !plainCureLine(item) || item.quantity !== 1)) {
        throw new Error('Votre panier contient une cure personnalisée ou plusieurs unités. Ajustez-le depuis l’icône panier avant de continuer.');
      }
      if (purchaseConfirmed(cart, variantId)) return;
      const selectedExists = () => cureLines(cart).some((item) => plainCureLine(item)
        && String(item.variant_id ?? item.id) === variantId && item.quantity === 1);
      if (!selectedExists()) {
        // Add first: a sold-out choice must not remove the previous confirmed cure.
        await requestAndConfirm('cart/add.js', { items: [{ id: variantId, quantity: 1 }] },
          (current) => cureLines(current).some((item) => plainCureLine(item)
            && String(item.variant_id ?? item.id) === variantId && item.quantity === 1));
      }
      const current = cureLines(cart);
      if (current.some((item) => !plainCureLine(item) || item.quantity !== 1)) {
        throw new Error('Votre panier a changé. Vérifiez les quantités depuis l’icône panier avant de continuer.');
      }
      const obsolete = current.filter((item) => String(item.variant_id ?? item.id) !== variantId);
      if (obsolete.length) {
        if (obsolete.some((item) => typeof item.key !== 'string' || !item.key)) {
          throw new Error('Impossible de confirmer la cure du panier. Vérifiez votre panier avant de continuer.');
        }
        const updates = Object.fromEntries(obsolete.map((item) => [item.key, 0]));
        await requestAndConfirm('cart/update.js', { updates }, (result) => purchaseConfirmed(result, variantId));
      }
      if (!purchaseConfirmed(cart, variantId)) {
        throw new Error('Le panier a changé. Vérifiez votre sélection avant de continuer.');
      }
    };
    const addToCart = async () => {
      if (mutationPending || checkoutPending || !selectedOffer?.available) return;
      const variantId = selectedOffer.variantId;
      mutationPending = true;
      ++refreshVersion;
      cartError(); productError(); syncButtons(); renderCart();
      let success = false;
      try {
        await ensureSingleCure(variantId);
        success = true;
      } catch (error) {
        productError(error.message || 'Impossible de confirmer votre cure. Vérifiez votre panier puis réessayez.');
      } finally { mutationPending = false; syncButtons(); renderCart(); }
      if (success) { productError(); startCheckout(); }
    };
    window.addEventListener('pageshow', (event) => {
      checkoutPending = false;
      requestAnimationFrame(() => {
        updateOffer(selectionFromURL() || offers.find((offer) => offer.radio.checked) || selectedOffer);
        if (event.persisted && !mutationPending) refreshCart().catch((error) => cartError(error.message));
      });
    });
    window.addEventListener('popstate', () => updateOffer(selectionFromURL() || selectedOffer));
    $('#cart-icon-bubble')?.addEventListener('click', (event) => {
      event.preventDefault(); openCart();
      if (!mutationPending) refreshCart().then(() => cartError()).catch((error) => cartError(error.message));
    });
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      $$('.drawer__close', drawer).forEach((button) => button.addEventListener('click', closeCart));
      $('#CartDrawer-Overlay', drawer)?.addEventListener('click', closeCart);
      $$('.drawer__inner-empty .button, [data-original-href="/collections/all"]', drawer).forEach((link) => {
        link.addEventListener('click', (event) => { event.preventDefault(); closeCart(); });
      });
    }
    document.addEventListener('submit', (event) => {
      if (event.target.matches('product-form form, [data-type="add-to-cart-form"], [data-local-product-form]')) {
        event.preventDefault(); addToCart();
      } else if (event.target.id === 'CartDrawer-Form') {
        event.preventDefault(); startCheckout();
      }
    }, true);
    $$('.atc-button[type="button"], [data-local-add-to-cart]').forEach((button) => button.addEventListener('click', addToCart));
    renderCart();
    refreshCart().catch((error) => cartError(error.message));

    // Full-width reference CTA appears after the main CTA has passed above the viewport.
    const heroCTA = $('product-form .atc-button, [data-local-product-form] .atc-button');
    if (heroCTA) {
      let stickyCTA = $('.sticky-cart-button.uplinkly-sticky-cart-button');
      if (!stickyCTA) {
        stickyCTA = make('button', 'sticky-cart-button uplinkly-sticky-cart-button', 'Acheter maintenant');
        stickyCTA.type = 'button';
        document.body.append(stickyCTA);
      }
      Object.assign(stickyCTA.style, {
        fontFamily: 'Poppins, sans-serif', fontWeight: '700', fontSize: '19px',
        lineHeight: '22.8px', backgroundColor: 'rgb(0, 150, 97)', color: '#fff',
        border: '0', borderRadius: '8px', padding: '0 30px', position: 'fixed',
        zIndex: '999', left: '0', right: '0', width: '100%', bottom: '0',
        textAlign: 'center', margin: '0', cursor: 'pointer', display: 'none',
      });
      stickyCTA.addEventListener('click', addToCart);
      const labelSticky = () => syncButtons();
      labelSticky();
      document.addEventListener('veranelle:offer-change', labelSticky);
      const footer = $('footer.footer, footer, [role="contentinfo"]');
      const updateSticky = () => {
        const viewportHeight = window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight;
        // Footer navigation and consent controls must stay outside the fixed purchase button.
        const footerVisible = footer && footer.getBoundingClientRect().top <= viewportHeight;
        const visible = heroCTA.getBoundingClientRect().bottom <= 0 && !footerVisible;
        stickyCTA.style.display = visible ? 'block' : 'none';
        stickyCTA.setAttribute('aria-hidden', String(!visible));
      };
      let stickyFrame = 0;
      const scheduleSticky = () => {
        if (stickyFrame) return;
        stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateSticky(); });
      };
      document.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky);
      window.addEventListener('load', scheduleSticky, { once: true });
      window.addEventListener('pageshow', scheduleSticky);
      if ('ResizeObserver' in window) {
        const stickyObserver = new ResizeObserver(scheduleSticky);
        stickyObserver.observe(heroCTA);
        if (footer) stickyObserver.observe(footer);
      }
      updateSticky();
    }

    // Testimonial slides stay touch-scrollable; dots and keyboard arrows share state.
    $$('.review-items-container slideshow-component, [data-local-slideshow]').forEach((component) => {
      const strip = $('.slideshow', component);
      const slides = $$('.slideshow__slide', component);
      const dots = $$('.slider-counter__link', component);
      if (!strip || !slides.length) return;
      let active = 0;
      const show = (index, move = true) => {
        active = (index + slides.length) % slides.length;
        dots.forEach((dot, position) => {
          dot.classList.toggle('slider-counter__link--active', position === active);
          dot.setAttribute('aria-current', position === active ? 'true' : 'false');
        });
        slides.forEach((slide, position) => slide.setAttribute('aria-hidden', String(position !== active)));
        if (move) strip.scrollTo({ left: slides[active].offsetLeft - slides[0].offsetLeft, behavior: scrollBehavior() });
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      $('.slider-button--prev', component)?.addEventListener('click', () => show(active - 1));
      $('.slider-button--next', component)?.addEventListener('click', () => show(active + 1));
      component.addEventListener('keydown', (event) => {
        if (!event.target.closest('.slider-counter__link') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); show(active + (event.key === 'ArrowLeft' ? -1 : 1)); dots[active]?.focus();
      });
      let frame = 0;
      strip.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const width = slides[0].offsetWidth || strip.clientWidth;
          if (width) show(Math.round(strip.scrollLeft / width), false);
        });
      }, { passive: true });
      show(0, false);
    });

    // Header drawers/search use only the local document and never call Shopify search.
    $$('header-drawer > details, details-modal > details').forEach((details) => {
      const menu = details.closest('header-drawer');
      const dialog = menu ? $('.menu-drawer', details) : $('.search-modal', details);
      if (!dialog) return;
      const summary = $('summary', details);
      const close = () => {
        details.open = false;
        details.classList.remove('menu-opening');
        summary?.setAttribute('aria-expanded', 'false');
        deactivateDialog(dialog);
      };
      details.addEventListener('toggle', () => {
        summary?.setAttribute('aria-expanded', String(details.open));
        if (details.open) {
          details.classList.add('menu-opening');
          const header = $('sticky-header, .header-wrapper');
          document.documentElement.style.setProperty('--header-bottom-position', `${header?.getBoundingClientRect().bottom || 0}px`);
          activateDialog(dialog, close, menu ? $('.menu-drawer__close-btn', details) : $('input[type="search"]', details));
        } else { details.classList.remove('menu-opening'); deactivateDialog(dialog); }
      });
      $$('.menu-drawer__close-btn, .search-modal__close-button, .modal-overlay', details).forEach((node) => node.addEventListener('click', close));
      if (menu) {
        $$('a[href^="#"]', dialog).forEach((link) => link.addEventListener('click', () => {
          // Expand a targeted FAQ row before native anchor navigation scrolls to it.
          const id = link.getAttribute('href').slice(1);
          const target = id ? document.getElementById(id) : null;
          const accordion = target?.closest('details');
          if (accordion) accordion.open = true;
          close();
        }));
      }
      const searchForm = $('form[role="search"]', details);
      const searchInput = $('input[type="search"]', details);
      const results = $('[data-predictive-search]', details);
      if (searchForm && searchInput && results) {
        results.replaceChildren();
        searchInput.removeAttribute('aria-owns');
        results.id = 'local-product-search-results';
        searchInput.setAttribute('aria-controls', results.id);
        const displaySearch = () => {
          const term = searchInput.value.trim().toLocaleLowerCase('fr');
          results.replaceChildren();
          results.style.display = term ? 'block' : '';
          searchInput.setAttribute('aria-expanded', String(Boolean(term)));
          const reset = $('.reset__button', searchForm);
          reset?.classList.toggle('hidden', !term);
          if (!term) return;
          const title = productTitle();
          const searchable = `${title} romarin huile cure croissance cheveux rosemary oil`.toLocaleLowerCase('fr');
          if (searchable.includes(term)) {
            const match = make('button', 'button button--tertiary', title);
            match.type = 'button'; match.id = 'local-product-search-result';
            match.addEventListener('click', () => { close(); $('.product__title')?.scrollIntoView({ behavior: scrollBehavior(), block: 'start' }); });
            results.append(match);
          } else {
            const message = make('p', 'predictive-search__item', 'Aucun résultat');
            message.id = 'local-product-search-result'; results.append(message);
          }
        };
        searchInput.addEventListener('input', displaySearch);
        searchForm.addEventListener('submit', (event) => { event.preventDefault(); displaySearch(); });
        searchForm.addEventListener('reset', () => requestAnimationFrame(displaySearch));
      }
    });

    // Existing review content/provenance remains unchanged when sorting or paging.
    $$('[data-veranelle-reviews]').forEach((root) => {
      const list = $('[data-reviews-list]', root);
      const items = $$('[data-review-item]', root);
      const sort = $('select[data-review-sort]', root);
      if (!list || !items.length) return;
      let page = 1;
      let order = [...items];
      const pages = Math.ceil(items.length / 5);
      const render = () => {
        order.forEach((item, index) => { item.hidden = index < (page - 1) * 5 || index >= page * 5; list.append(item); });
        $$('[data-review-page]', root).forEach((button) => {
          const target = button.dataset.reviewPage;
          button.disabled = (target === 'prev' && page === 1) || (target === 'next' && page === pages);
          if (target === 'prev' || target === 'next') button.hidden = button.disabled;
          if (/^\d+$/.test(target)) {
            button.classList.toggle('jdgm-curt', Number(target) === page);
            if (Number(target) === page) button.setAttribute('aria-current', 'page');
            else button.removeAttribute('aria-current');
          }
        });
        const status = $('[data-review-page-status]', root);
        if (status) status.textContent = `Page ${page} sur ${pages}`;
      };
      sort?.addEventListener('change', () => {
        order = [...items].sort((a, b) => {
          const bySource = Number(a.dataset.sourceOrder || 0) - Number(b.dataset.sourceOrder || 0);
          const rating = Number(b.dataset.rating || 0) - Number(a.dataset.rating || 0);
          return sort.value === 'rating-desc' ? rating || bySource : sort.value === 'rating-asc' ? -rating || bySource : bySource;
        });
        page = 1; render();
      });
      $$('[data-review-page]', root).forEach((button) => button.addEventListener('click', () => {
        const target = button.dataset.reviewPage;
        const next = target === 'prev' ? page - 1 : target === 'next' ? page + 1 : Number(target);
        if (!Number.isInteger(next)) return;
        page = Math.min(pages, Math.max(1, next)); render();
        list.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      }));
      render();
    });
    $$('[data-funnel-pending]').forEach((control) => {
      if (!control.matches('input[type="radio"], .atc-button, [data-cure-cta]')) control.disabled = false;
      control.removeAttribute('data-funnel-pending');
    });
    offers.forEach((offer) => { offer.radio.disabled = !offer.available; });
    interactionsReady = true;
    document.documentElement.dataset.funnelControlsReady = 'true';
    syncButtons();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
